export default "__VITE_ASSET__D0$6WrNI__"